<app-document-countries
  [name]="'Правила вождения'"
  [countries]="countries"
></app-document-countries>
